<template>
  <div>
    <HeaderVue></HeaderVue>
    <BannerVue></BannerVue>

    <EnrollSuccessVue
      :info="queryInfo"
      @navBack="handleNavBack"
      v-if="status == 1"
    ></EnrollSuccessVue>
    <NoEnrollVue
      :showBatchList="showBatchList"
      :info="queryInfo"
      @navBack="handleNavBack"
      @toggle-batch="showBatchList = !showBatchList"
      v-if="status == 2"
    ></NoEnrollVue>

    <BatchWrapperVue
      v-show="showBatchList"
      :batchList="batchList"
    ></BatchWrapperVue>
    <FooterVue></FooterVue>
  </div>
</template>

<script>
import BannerVue from "./components/Banner.vue";
import BatchWrapperVue from "./components/BatchWrapper.vue";
import EnrollSuccessVue from "./components/EnrollSuccess.vue";
import FooterVue from "./components/Footer.vue";
import HeaderVue from "./components/Header.vue";
import NoEnrollVue from "./components/NoEnroll.vue";

import { batchList, queryEnroll } from "../../services/enroll";

export default {
  name: "EnrollResult",
  components: {
    HeaderVue,
    BannerVue,
    FooterVue,
    BatchWrapperVue,
    EnrollSuccessVue,
    NoEnrollVue,
  },
  data() {
    return {
      status: 0, // 0: 未查询, 1: 录取成功 2: 未录取
      batchList: [],
      queryInfo: {},
      showBatchList: false,
    };
  },
  created() {
    this.queryInfo = this.$route.query;
    this.getData();
    this.getBatchList();
  },
  watch: {},
  methods: {
    async getData() {
      const loading = this.$loading({
        lock: true,
        text: "查询中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        const res = await queryEnroll(
          this.queryInfo.number,
          this.queryInfo.idCard
        );

        if (res) {
          this.queryInfo = res;
          this.status = 1;
        } else {
          this.status = 2;
        }
      } catch (error) {
      } finally {
        loading.close();
      }
    },

    handleNavBack() {
      this.$router.push({ name: "enroll" });
    },

    async getBatchList() {
      const res = await batchList();
      this.batchList = res;
    },
    handleQuerySuccess(info) {
      this.status = 1;
      this.queryInfo = info;
      this.showBatchList = false;
    },
    handleQueryFail(info) {
      this.status = 2;
      this.queryInfo = info;
      this.showBatchList = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>